/**
 * Attendance schemas — clock-in/clock-out for staff.
 */

import { z } from 'zod';
import { idSchema, iso8601Schema, pageInput, sortOrderSchema } from './common';

export const attendanceOutputSchema = z.object({
  id: idSchema,
  userId: idSchema,
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  clockInAt: iso8601Schema.nullable(),
  clockOutAt: iso8601Schema.nullable(),
  breakMinutes: z.number().int().min(0).nullable(),
  note: z.string().max(1000).nullable(),
  location: z.string().max(200).nullable(),
  createdAt: iso8601Schema,
  updatedAt: iso8601Schema,
});
export type AttendanceOutput = z.infer<typeof attendanceOutputSchema>;

export const clockInInputSchema = z.object({
  note: z.string().max(1000).nullable().optional(),
  location: z.string().max(200).nullable().optional(),
});
export type ClockInInput = z.infer<typeof clockInInputSchema>;

export const clockOutInputSchema = z.object({
  note: z.string().max(1000).nullable().optional(),
});
export type ClockOutInput = z.infer<typeof clockOutInputSchema>;

export const updateAttendanceInputSchema = z.object({
  clockInAt: iso8601Schema.nullable().optional(),
  clockOutAt: iso8601Schema.nullable().optional(),
  breakMinutes: z.number().int().min(0).nullable().optional(),
  note: z.string().max(1000).nullable().optional(),
  location: z.string().max(200).nullable().optional(),
});
export type UpdateAttendanceInput = z.infer<typeof updateAttendanceInputSchema>;

export const listAttendanceInputSchema = pageInput.extend({
  userId: idSchema.optional(),
  from: iso8601Schema.optional(),
  to: iso8601Schema.optional(),
  sortBy: z.enum(['date', 'createdAt']).default('date'),
  sortOrder: sortOrderSchema,
});
export type ListAttendanceInput = z.infer<typeof listAttendanceInputSchema>;
